import { useCallback, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Socket } from 'socket.io-client';
import { CARGO_TRIPS_MANY } from 'api/query-keys';
import type { ICargoTripInvalidateManyEvent } from './types';
import { ESocketEventName } from './types';

export const useHandleCargoTripInvalidateMany = (socket: Socket) => {
  const queryClient = useQueryClient();

  const handler = useCallback(
    async (event: ICargoTripInvalidateManyEvent) => {
      const tripId = event.payload.tripId;

      await queryClient.invalidateQueries([CARGO_TRIPS_MANY, tripId]);
    },
    [queryClient],
  );

  useEffect(() => {
    socket.on(ESocketEventName.cargoTripInvalidateMany, handler);

    return () => {
      socket.removeListener(ESocketEventName.cargoTripInvalidateMany, handler);
    };
  }, [handler, socket]);
};
